<template>
  <div>
    <div>
      <Echart style="z-index:1"
        id="nationalMapChart"
        ref="nationalMapChartRef"
        :options="options"
        height="31vh"
        width="40vw"
      ></Echart>
    </div>
  </div>
</template>

<script>
import Echart from "@/common/echart";
import { mapNum, mapMon } from "@/api/map.js";
export default {
  data() {
    return {
      newsShow: false,
      options: {},
      geoCoordMap: "",
      area: 110000, //区域码
      proName: "北京市",
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {},
  watch: {
    cdata: {
      handler(newData) {
        // 设置点的位置(经纬度)
        this.geoCoordMap = {
          山东: [117.000923, 36.675807],
          河北: [115.48333, 38.03333],
          吉林: [125.35, 43.88333],
          黑龙江: [127.63333, 47.75],
          辽宁: [123.38333, 41.8],
          内蒙古自治区: [111.670801, 41.818311],
          新疆维吾尔自治区: [87.68333, 43.76667],
          甘肃: [103.73333, 36.03333],
          宁夏回族自治区: [106.26667, 37.46667],
          山西: [112.53333, 37.86667],
          陕西: [108.95, 34.26667],
          河南: [113.65, 34.76667],
          安徽: [117.283042, 31.86119],
          江苏: [119.78333, 32.05],
          浙江: [120.2, 30.26667],
          福建: [118.3, 26.08333],
          广东: [113.23333, 23.16667],
          江西: [115.9, 28.68333],
          海南: [110.35, 20.01667],
          广西壮族自治区: [108.320004, 22.82402],
          贵州: [106.71667, 26.56667],
          湖南: [113.0, 28.21667],
          湖北: [114.298572, 30.584355],
          四川: [104.06667, 30.66667],
          云南: [102.73333, 25.05],
          西藏自治区: [91.0, 30.6],
          青海: [96.75, 36.56667],
          天津市: [117.2, 39.13333],
          上海市: [121.55333, 31.2],
          重庆市: [106.45, 29.56667],
          北京市: [116.41667, 39.91667],
          台湾: [121.3, 25.03],
          香港特别行政区: [114.1, 22.2],
          澳门特别行政区: [113.5, 22.2],
        };
        let seriesData = [];
        let convertData = function(data) {
          let scatterData = [];
          for (var i = 0; i < data.length; i++) {
            var geoCoord = this.geoCoordMap[data[i].name];
            if (geoCoord) {
              scatterData.push({
                name: data[i].name,
                value: geoCoord.concat(data[i].value),
              });
            }
          }
          return scatterData;
        };
        this.options = {
          showLegendSymbol: true,
          tooltip: {
            trigger: "item",
            textStyle: {
              fontSize: 14,
              lineHeight: 22,
            },
            position: (point) => {
              // 固定在顶部
              return [point[0] + 20, point[1] - 15];
            },
            // 如果需要自定义 tooltip样式，需要使用formatter
            /*
              formatter: params => {
                return `<div style=""> ... </div>`
              }
            */
          },
          visualMap: {
            min: 0,
            max: 2500,
            text: ["高", "低"],
            show: true,
            right: "auto", //组件离容器右侧的距离,'20%'
            bottom: "5%", //组件离容器下侧的距离,'20%'
            seriesIndex: 0,
            orient: "horizontal",
            itemWidth: 10, //图形的宽度，即长条的宽度。
            itemHeight: 80, //图形的高度，即长条的高度。
            calculable: true,
            // 颜色
            inRange: {
              color: ["rgba(41,166,206, .5)", "rgba(69,117,245, .9)"],
            },
          },
          // 底部背景
          geo: {
            show: true,
            aspectScale: 0.85, //长宽比
            zoom: 1.2,
            top: "10%",
            left: "10%",
            map: "china",
            roam: false,
            itemStyle: {
              normal: {
                areaColor: "rgba(0,0,0,0)",
                shadowColor: "rgba(7,114,204, .8)",
              },
              emphasis: {
                areaColor: "#00aeef",
              },
            },
          },
          series: [
            {
              name: "相关指数",
              type: "map",
              aspectScale: 0.85, //长宽比
              zoom: 1.2,
              mapType: "china", // 自定义扩展图表类型
              top: "10%",
              left: "10%",
              itemStyle: {
                normal: {
                  color: "red",
                  areaColor: "rgba(19,54,162, .5)",
                  borderColor: "rgba(0,242,252,.3)",
                  borderWidth: 1,
                  shadowBlur: 7,
                  shadowColor: "#00f2fc",
                },
                emphasis: {
                  areaColor: "#4f7fff",
                  borderColor: "rgba(0,242,252,.6)",
                  borderWidth: 2,
                  shadowBlur: 10,
                  shadowColor: "#00f2fc",
                },
              },
              label: {
                formatter: (params) => `${params.name}`,
                show: false,
                position: "insideRight",
                textStyle: {
                  fontSize: 14,
                  color: "#efefef",
                },
                emphasis: {
                  textStyle: {
                    color: "#fff",
                  },
                },
              },
              data: newData,
            },
            {
              // 散点图
              type: "effectScatter",
              coordinateSystem: "geo",
              symbolSize: 7,
              effectType: "ripple",
              legendHoverLink: false,
              showEffectOn: "render",
              rippleEffect: {
                period: 4,
                scale: 2.5,
                brushType: "stroke",
              },
              zlevel: 1,
              itemStyle: {
                normal: {
                  color: "#99FBFE",
                  shadowBlur: 5,
                  shadowColor: "#fff",
                },
              },
              data: convertData(seriesData),
            },
          ],
        };
        // 重新选择区域
        this.handleMapRandomSelect();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    // 开启定时器
    startInterval() {
      const _self = this;
      // 应通过接口获取配置时间，暂时写死5s
      const time = 2000;
      if (this.intervalId !== null) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        _self.reSelectMapRandomArea();
      }, time);
    },
    // 重新随机选中地图区域
    reSelectMapRandomArea() {
      const length = 34;
      this.$nextTick(() => {
        try {
          const map = this.$refs.nationalMapChartRef.chart;
          let index = Math.floor(Math.random() * length);
          while (index === this.preSelectMapIndex || index >= length) {
            index = Math.floor(Math.random() * length);
          }
          map.dispatchAction({
            type: "mapUnSelect",
            seriesIndex: 0,
            dataIndex: this.preSelectMapIndex,
          });
          map.dispatchAction({
            type: "showTip",
            seriesIndex: 0,
            dataIndex: index,
          });
          map.dispatchAction({
            type: "mapSelect",
            seriesIndex: 0,
            dataIndex: index,
          });
          this.preSelectMapIndex = index;
        } catch (error) {
          // console.log(error);
        }
      });
    },
    handleMapRandomSelect() {
      this.$nextTick(() => {
        try {
          const map = this.$refs.nationalMapChartRef.chart;
          const _self = this;
          setTimeout(() => {
            _self.reSelectMapRandomArea();
          }, 0);
          // 移入区域，清除定时器、取消之前选中并选中当前
          map.on("click", function(params) {
            this.proName = params.data.name + "省";
            console.log(this.proName, "222");
            mapNum({
              proName: this.proName,
            }).then((res) => {
              console.log(res, "张大2");
              this.area = res.data.data.id;
              // mapMon({
              //    area:this.area
              //    }).then(res=>{
              //    console.log(res,'sdf')
              //  })
            });
            //  mapMon({
            //    area:110000
            //    }).then(res=>{
            //    console.log(res,'sdf')
            //  })

            //  this.lond();
            //  this.store.commit('mapAdd',this.city)
            //     console.log(this.$store.state.city,'vuex')
            clearInterval(_self.intervalId);
            map.dispatchAction({
              type: "mapUnSelect",
              seriesIndex: 0,
              dataIndex: _self.preSelectMapIndex,
            });
            map.dispatchAction({
              type: "mapSelect",
              seriesIndex: 0,
              dataIndex: params.dataIndex,
            });
            _self.preSelectMapIndex = params.dataIndex;
          });
          // 移出区域重新随机选中地图区域，并开启定时器
          map.on("globalout", function() {
            _self.reSelectMapRandomArea();
            _self.startInterval();
          });

          this.startInterval();
        } catch (error) {
          // console.log(error);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.map_time {
  width: 100vh;
  height: 100vh;
  border: 1px solid red;
  display: flex;
  justify-content: space-around;
}
.onst {
  border: 1px solid red;
}
.right_time {
  width: 100px;
  // height: 200px;
  background: red;
}
</style>
